import React from "react";
import {
  Loader, CheckCircle, Package, Truck, Gift, PieChart, XCircle, List,
  AlertCircle, PlusCircle, ShoppingBag, ShoppingCart, Globe, Send, Shield,
  Unlock, Archive, Link, PlusSquare, Grid, TrendingUp, Volume2, Sliders,
  Image, Zap, Award, Flag, Repeat, Clock, Layers, Tag, RefreshCw, UserCheck,
  Calendar, Briefcase, FileText, CreditCard, Coffee, Inbox, User, RotateCcw,
  XOctagon, RefreshCcw, Camera, Star, DollarSign, Anchor, Heart, Navigation,
  Users, Home, Percent, MapPin, Circle,
} from "react-feather";

// Submenu icons, keyed by menu title. Each has a hover animation that fits
// what it shows (see .sb-anim--* in sidebar.css):
//   spin, pop, bounce, drive, wiggle, shake, slide, pulse, fly, swing, beat
const SUB_ICONS = {
  // Orders
  Processing: [Loader, "spin"],
  Confirmed: [CheckCircle, "pop"],
  Packing: [Package, "bounce"],
  "On the way": [Truck, "drive"],
  Delivered: [Gift, "wiggle"],
  "Partial Delivered": [PieChart, "spin"],
  Cancelled: [XCircle, "shake"],
  "All Orders": [List, "slide"],
  "Payment Due Orders": [AlertCircle, "pulse"],

  // Pre-orders
  "New Orders": [PlusCircle, "spin"],
  "Picked Orders": [ShoppingBag, "bounce"],
  Purchased: [ShoppingCart, "drive"],
  "Abroad Warehouse": [Globe, "spin"],
  "Ready For Fly": [Send, "fly"],
  "Bangladesh Customs": [Shield, "pop"],
  "Custom Released": [Unlock, "wiggle"],
  "KIDO Warehouse": [Archive, "bounce"],
  Pending: [Clock, "spin"],
  Rejected: [XOctagon, "shake"],
  "Order Request": [Inbox, "bounce"],
  "Order Agents": [UserCheck, "pop"],

  // Money
  "Cash in/Cash out": [Repeat, "spin"],
  "Cash in/out History": [Clock, "spin"],
  "Cash Summary": [PieChart, "spin"],
  "Currency Converter": [RefreshCw, "spin"],
  "Daily Cost": [Calendar, "pop"],
  Monthly: [Calendar, "pop"],
  Salary: [DollarSign, "beat"],
  Invest: [TrendingUp, "slide"],
  Loans: [CreditCard, "slide"],
  Office: [Coffee, "wiggle"],
  Employee: [Briefcase, "bounce"],
  "Customer wise": [UserCheck, "pop"],
  History: [Clock, "spin"],
  Refund: [RotateCcw, "spin"],
  "Payment Request": [Send, "fly"],
  "Payment Requests": [DollarSign, "beat"],
  "1688 Payment Link": [Link, "wiggle"],
  Invoice: [FileText, "slide"],

  // Products and shop
  "Add Product": [PlusSquare, "pop"],
  "All Products": [Grid, "pop"],
  "Buy Products": [ShoppingCart, "drive"],
  "All Sells": [TrendingUp, "slide"],
  "Restock Dashboard": [RefreshCcw, "spin"],
  Categories: [Layers, "bounce"],
  Brands: [Award, "swing"],
  Attributes: [Sliders, "wiggle"],
  Banners: [Image, "pop"],
  Campaigns: [Flag, "swing"],
  "Boosting/Promotion": [Zap, "pulse"],
  "Shop By Concern": [Heart, "beat"],
  Reviews: [Star, "spin"],
  "Review Screenshot": [Camera, "pop"],
  Announcements: [Volume2, "wiggle"],
  "All Coupons": [Tag, "swing"],
  Coupons: [Percent, "spin"],

  // Shipping
  Shipping: [Anchor, "swing"],
  "Shipping charges": [Truck, "drive"],
  "Courier Charge": [Truck, "drive"],
  Transport: [Navigation, "fly"],

  // People and settings
  "User List": [Users, "bounce"],
  "All Admins": [Users, "bounce"],
  Profile: [User, "pop"],
  Dashboard: [Home, "bounce"],
  Localization: [MapPin, "bounce"],
};

const SubIcon = ({ title }) => {
  const [Icon, anim] = SUB_ICONS[title] || [Circle, "pop"];
  return (
    <span className={`sb-sub-icon sb-anim--${anim}`} aria-hidden="true">
      <Icon size={14} />
    </span>
  );
};

export default SubIcon;
